(function() {
  'use strict';

  eclipseApp
    .directive('getElementInfo', [
      '$timeout',
      function($timeout) {
        return {
          link: function(s, e, a) {
            $timeout(function() {
              console.log('@naa getElementInfo ', e[0].clientHeight, a, s);
              var _offset = 43;
              var _clientHeight = e[0].clientHeight;
              var _calculatedHeight = _clientHeight - _offset;

              s.$parent.elementHandlers = s.$parent.elementHandlers || {};
              s.$parent.elementHandlersHeights = s.$parent.elementHandlersHeights || [];
              s.$parent.elementHandlersHeights.push({
                clientHeight: _clientHeight,
                offset: _offset,
                calculatedHeight: _calculatedHeight
              });

              s.$parent.elementHandlers[a.getElementInfo] = _calculatedHeight;
              // angular.copy({
              //   clientHeight: _clientHeight,
              //   offset: _offset,
              //   calculatedHeight: _calculatedHeight
              // });
            });
          }
        };
      }
    ])
    .directive('internetPackageSelectorV2', [
      'cartManager',
      'accountDashboardManager',
      '$http',
      '$rootScope',
      'uteEndpoint',
      '$timeout',
      'internetPackageService',
      'samKeyService',
      '$state',
      '$modal',
      'commonService',
      '$q',
      'buyService',
      'janrainService',
      'uteLocale',
      'authUtils',
      'brtEndpoint',
      'serviceabilityService',
      'brtSwitchCMS',
      'buySession',
      '$window',
      '$interpolate',
      function(
        cartManager,
        accountDashboardManager,
        $http,
        $rootScope,
        uteEndpoint,
        $timeout,
        internetPackageService,
        samKeyService,
        $state,
        $modal,
        commonService,
        $q,
        buyService,
        janrainService,
        uteLocale,
        authUtils,
        brtEndpoint,
        serviceabilityService,
        brtSwitchCMS,
        buySession,
        $window,
        $interpolate
      ) {
        return {
          restrict: 'EA',
          templateUrl: function() {
            switch ($rootScope.currentState.name) {
              case 'myAccount':
                break;
              case 'btsOffer':
                return 'modules/core/views/bts-package-selector.html';
              default:
                return 'modules/core/views/internet-package-selector-v2.html';
            }
          },
          replace: true,
          controller: [
            '$scope',
            function($scope) {
              var PREV_SELECTED_OFFER_KEY = 'prev_sel_offer';

              var self = this;
              //Accrem- Start
              $scope.radioBtnFocus = function(event) {
                angular
                  .element(event.target)
                  .parent()
                  .addClass('highlight');
              };
              $scope.radioBtnBlur = function(event) {
                angular
                  .element(event.target)
                  .parent()
                  .removeClass('highlight');
              }; //Accrem-end
              // self.hasJanrainSession = false;
              self.isAuth = function() {
                return $rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent();
              };
              self.isLoggedIn = $rootScope.ruiMethods.user.is.loggedIn;
              self.isAgent = $rootScope.ruiMethods.user.is.agent;
              self.isEligibleToCheckout = function() {
                if ($state.current.parent === 'myAccount.internet') {
                  return true;
                } else {
                  return buyService.isEligibleToCheckout();
                }
              };

              self.userContext = buyService.isAccountEligibleToCheckout;
              self.samKeyInit = angular.copy($rootScope.userPref);

              // console.log('@internetPackageSelector (self.hasJanrainSession) ', self.hasJanrainSession, samKeyService.tier);

              $scope.internetOffers = [];

              this.onUpdateHeight = function(event, height) {
                var maxHeight = 0;

                angular.element('.package-item').css('height', 'auto');
                angular.element('.package-selector-wrapper-internet').css('height', 'auto');
                angular.element('.package-border-arrow').css('top', 'auto');
                angular.element('.package-detail').css('top', 'auto');

                $.each(angular.element('.package-item'), function(index, element) {
                  if (angular.element(element).outerHeight() > maxHeight) {
                    maxHeight = angular.element(element).outerHeight();
                  }
                });

                // angular.element('.package-item').css('height', maxHeight);
                angular
                  .element('.package-selector-wrapper-internet')
                  .css('height', maxHeight + angular.element('.package-detail').outerHeight());
                angular.element('.package-border-arrow').css('top', maxHeight - 5);
                angular.element('.package-detail').css('top', maxHeight);
              };

              /**
               * watcher for change package button in my account dashboard page.
               */
              $scope.$watch('displayInternetPkgSelector', function(display) {
                if (display) {
                }
                $timeout(self.onUpdateHeight, 50);
              });

              /**
               * connecting internet package selector as a browsing mode.
               */
              // connecting internet package selector to browsing mode. If logged in user doesn't have internet package, it is redirected to run this function.
              this.linkBrowseMode = function() {
                //if ($scope.packageMode != 'browsing')
                //  $scope.packageMode = 'browsing';
                var activeTier = cartManager.internet.tierInCart();
                if (activeTier) $scope.selectedOfferDetail = activeTier.selectedOffer.content.offerDetails;
                else $scope.selectedOfferDetail = $scope.internetPackage[0].offers[0].content.offerDetails;
              };

              /**
               * restructuring offers to tier level by attaching them to tier.
               */
              this.attachOfferToTier = function() {
                for (var a = 0, tier; (tier = $scope.internetPackage[a]); a++) {
                  tier.offers = [];
                  for (var i = 0, product; (product = tier.products[i]); i++) {
                    if (product.offers && product.offers.length > 0) {
                      for (var j = 0, offer; (offer = product.offers[j]); j++) {
                        offer.productId = product.id;
                        offer.tierId = tier.tierId;
                        tier.offers.push(offer);
                      }
                    }
                  }
                }
              };

              if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
                samKeyService.resetSamKey();
                cartManager.cleanCart().then(
                  function(res) {
                    console.log('cart is cleaned');
                  },
                  function(resErr) {
                    _satellite.setVar('error', 'FHSI | searchCreditCard  failed');
                    _satellite.track('bfa-fhsi-error');
                    notifier.notify.error();
                  }
                );

                if ($rootScope.ruiMethods.user.is.agent()) {
                  $window.sessionStorage.setItem('agentSelectedOffer', '{}');
                }

                if (buyService.getSession('profile')) {
                  buyService.cleanSessions();
                }
              }

              /**
               * sort offers (by price in asc order) of each tier in here
               */
              this.sortOffersInTierByPrice = function() {
                return _.each($scope.internetPackage, function(tier) {
                  tier.offers = _.sortBy(tier.offers, function(offer) {
                    return offer.offerPrice.price;
                  });
                });
              };

              /**
               * each internet tier should have selected offer by default. If there is no selected offer, first offer is set as a default offer.
               */
              this.setDefaultOfferInEachTier = function() {
                var a = 0;
                _.each($scope.internetPackage, function(tier) {
                  a++;
                  if ($scope.packageMode === 'change') {
                    var i = 0;
                    var hasSelected = false;
                    _.each(tier.offers, function(offer) {
                      i++;
                      if (offer.isCurrent) {
                        tier.selectedOffer = offer;
                        $scope.selectedOffer = offer;
                        $scope.selectedTier = a;
                        $scope.selectedPackageIdx = a;
                        accountDashboardManager.currentInternetPackage = angular.copy(tier);
                        hasSelected = true;
                      }
                    });
                    if (!hasSelected) tier.selectedOffer = tier.offers[0];
                  } else {
                    if ($scope.tierInCart()) {
                      if (tier.tierId == $scope.tierInCart().tierId) {
                        tier.selectedOffer = $scope.tierInCart().selectedOffer;
                        $scope.selectedTier = a;
                      } else {
                        tier.selectedOffer = tier.offers[0];
                      }
                    } else tier.selectedOffer = tier.offers[0];
                  }
                });
              };

              this.customerHasInternetService = function() {
                if ($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) {
                  if (
                    commonService.customerHasInternetService &&
                    commonService.internetAccountStatus !== 'SUSPENDED' &&
                    commonService.internetAccountStatus !== 'CANCELLED'
                  ) {
                    return true;
                  }
                }

                return false;
              };

              /*DSO-7843 Start - extending this for DSO-15392*/
              /*Requirement to display promos for the plans*/
              $scope.promos = {};
              $rootScope.language = uteLocale.language;
              if (!self.customerHasInternetService()) {
                buyService.getInternetPromos().then(function(data) {
                  $scope.promos = data;
                });
              }
              /*DSO-7843 End*/

              /**
               * get tier that's in cart
               */
              $scope.tierInCart = function() {
                if ($scope.packageMode && $scope.packageMode == 'change') {
                  return accountDashboardManager.tierInDashboard();
                } else return cartManager.internet.tierInCart();
              };

              /**
               * change selected offers
               */
              $scope.offerChange = function(currentTier, newOffer) {
                // if (!authUtils.isAuth()) return;
                //set is promo text display on cart-summary, review and confirmation pages
                /* if($scope.promos && $scope.promos[currentTier.tierId] && $scope.promos[currentTier.tierId]['display_promo_text']) {
              buyService.setPromoTierId(currentTier.tierId);
            } else {
               buyService.setPromoTierId(null);
            }*/

                currentTier.selectedOffer = newOffer;
                $scope.selectedOfferDetail = newOffer.content.offerDetails;
                for (var i = 0, tier; (tier = $scope.internetPackage[i]); i++) {
                  if (currentTier.tierId === tier.tierId) $scope.selectedTier = i + 1;
                }
              };

              /**
               * remove item from cart; pass in tier offer
               * skip removing if it is agent
               */
              $scope.removeFromCart = function(tierId, productId, offerId) {
                if (!$rootScope.ruiMethods.user.is.agent()) {
                  cartManager.internet.removeOffer(tierId, productId, offerId);
                }
              };

              $scope.addToCart = function(tier, $event, offerInContext) {
                $rootScope.promoOfferId = null;
                console.info('authUtils.isAuth() offerInContext ', offerInContext);
                console.info('authUtils.isAuth() tier ', tier);
                console.info('authUtils.isAuth() samKeyService.tier ', samKeyService.tier);

                // set session for tierId: skuId
                // for cross check with new offer list after user logs in
                var obj = {};
                obj[tier.tierId] = offerInContext[tier.tierId];
                obj.isAuthd = $rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent();
                window.sessionStorage.setItem(PREV_SELECTED_OFFER_KEY, JSON.stringify(obj));

                samKeyService.tier = tier;

                tier.selectedOffer = _.has(
                  $scope.tierInContext,
                  tier.tierId + '.' + offerInContext[tier.tierId] + '.details'
                )
                  ? $scope.tierInContext[tier.tierId][offerInContext[tier.tierId]].details
                  : {};

                // OLD IMPLEMENTATION
                // to always show the serviceability when not logged in and reset the samkey
                // if (!authUtils.isAuth()) {
                //   samKeyService.resetSamKey();
                //   samKeyService.showAvailabilityModal('internet', tier, 'cartSummary');
                //   return;
                // }

                var addToCartEventObj = {
                  trackingId: 'packageselector:addtocart',
                  overrideParams: {
                    prop12: 'fido:internet:buy:' + tier.name + ':' + tier.selectedOffer.name
                  },
                  element: $event.currentTarget
                };

                if ($scope.packageMode && $scope.packageMode == 'change') {
                  // hack to show promo warning modal
                  if (accountDashboardManager.confirmChangeInternetPackage()) {
                    $modal.open({
                      templateUrl: 'views/templates/modal/change-internet-package-already-confirmed.html',
                      controller: 'confirmChangeInternetModalCtrl'
                    });
                  } else {
                    accountDashboardManager.newInternetPackage = tier;
                    $modal.open({
                      templateUrl: 'views/templates/modal/pkg-promo-warning.html',
                      controller: 'changeInternetPromoWarningModalCtrl'
                    });
                  }
                } else {
                  var stopCustomer = false;
                  if ($rootScope.ruiMethods.user.is.loggedIn() || $rootScope.ruiMethods.user.is.agent()) {
                    if (
                      commonService.customerHasInternetService &&
                      (commonService.internetAccountStatus == 'SUSPENDED' ||
                        commonService.internetAccountStatus == 'CANCELLED')
                    ) {
                      stopCustomer = true;
                    }
                    //if (!commonService.customerHasWirelessService && !commonService.customerHasInternetService){
                    //  stopCustomer = true;
                    //}

                    var internetAcct = _.filter($rootScope.userInfo.accounts, function(account) {
                      return account.serviceName === 'Internet/TV';
                    });
                    if (internetAcct && (internetAcct || []).length > 0 && internetAcct[0].status == 'TENTATIVE') {
                      stopCustomer = true;
                    }
                  }

                  if (stopCustomer) {
                    $modal.open({
                      templateUrl: 'modules/core/views/contact-customer-care.html'
                    });
                  } else {
                    // add item to cart; check serviceability if samKey is set to 'default'
                    // if serviceability has not been done
                    if (self.samKey === 'default') {
                      if ($rootScope.currentState.name === 'btsOffer') {
                        samKeyService.showAvailabilityModal('btsPromotion', tier, 'cartSummary');
                      } else {
                        if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
                          samKeyService.showAvailabilityModal('internet', tier, 'buy');
                        } else {
                          samKeyService.showAvailabilityModal('internet', tier, 'cartSummary');
                        }
                      }
                    } else {
                      cartManager.internet.addOffer(tier, offerInContext ? offerInContext[tier.tierId] : null).then(
                        function() {
                          if (brtSwitchCMS.brtSwitch.isHybridFlow && $rootScope.ruiMethods.user.is.agent()) {
                            $state.go('buy');
                          } else {
                            $state.go('cartSummary');
                          }
                        },
                        function(reason) {
                          console.log(reason);
                          if (reason !== '60025') {
                            self.setDefaultOfferInEachTier();
                          }
                        }
                      );
                    }
                  }
                }
              };

              $scope.requestData = {
                offersLoaded: false,
                loadError: false,
                loading: true
              };

              // init fire
              this.init = function() {
                /*DSO-8458, check if address based product offerings is available for internet,
            if not skip the  "Search Product Offering by SAM Key" functionality after the serviceability check. Added Switch checking at calls*/
                self.samKey =
                  $rootScope.userPref && $rootScope.userPref.samKey ? $rootScope.userPref.samKey : 'default';

                // load statuses before initialization.
                $scope.requestData = {
                  offersLoaded: false,
                  loadError: false,
                  loading: true
                };
                $scope.serviceableAddress = function() {
                  var samKeyServiceableAddress = JSON.parse(
                    window.localStorage.getItem(
                      buySession.getCheckoutSessionKey(buySession.getKeyId('serviceableAddress', self.samKey))
                    )
                  );
                  var addressLabel = samKeyServiceableAddress ? samKeyServiceableAddress.label : '';
                  return addressLabel;
                };

                var q = [],
                  endpoint = null,
                  params = {};

                /**
                 * Waiting existingProductDetails to be finished for change internet package, because it is depend on SS.
                 */
                if (angular.isDefined($scope.existingProductDetailsExecuted)) {
                  // this code block is only executed when it is used in my account internet page.
                  if ($scope.existingProductDetailsExecuted) q.push($q.defer().resolve());
                  else {
                    var deferred = $q.defer();
                    q.push(deferred);
                    $scope.$watch(
                      'existingProductDetailsExecuted',
                      function() {
                        if ($scope.existingProductDetailsExecuted) deferred.resolve();
                      },
                      function() {
                        deferred.reject();
                      }
                    );
                  }
                } else {
                  // this code block is only executed when it is used in internet browse page.

                  if (self.customerHasInternetService()) {
                    //Temporary solution for as long as 'v1/browseHSIPackage' is not working

                    var callType = '';
                    callType = 'getExisting';
                    //callType = 'getBrowser';

                    if (callType === 'getBrowser') {
                      // browseHSIPackage is calling existingProductDetails in the server side, so we don't have to call it again.
                      endpoint = uteEndpoint('v1/browseHSIPackage');
                      params.accountNumber = commonService.internetAccountNumber;
                      q.push($q.defer().resolve());
                    } else {
                      // Manually call existingProductDetails and then call v2/changeInternetPackage
                      var promise = $http.post(uteEndpoint('v1/existingProductDetails'), {
                        accountNumber: commonService.internetAccountNumber,
                        subscriptionID: commonService.internetSubscriberNo
                      });
                      q.push(promise);
                    }
                  } else {
                    q.push($q.defer().resolve());
                  }

                  //q.push($q.defer().resolve());
                }

                if (self.customerHasInternetService()) {
                  if (!endpoint) {
                    endpoint = brtEndpoint('v3/changeInternetPackage');
                  }
                  params.accountNumber = commonService.internetAccountNumber;
                  params.subscriptionID = commonService.internetSubscriberNo;
                  params.samKey = self.samKey;
                  $scope.packageMode = 'change';
                } else {
                  endpoint = brtEndpoint('v2/internetOffers');
                  params.province = uteLocale.province;
                  params.userId = $rootScope.atg && $rootScope.atg.userId && $rootScope.atg.userId.value;
                  params.hashKey = $rootScope.atg && $rootScope.atg.hashKey && $rootScope.atg.hashKey.value;
                  params.samKey =
                    brtSwitchCMS.brtSwitch && brtSwitchCMS.brtSwitch.fetchAddressBasedOffers ? self.samKey : 'default';
                  if ($rootScope.currentState.name === 'btsOffer') {
                    //fetching back to school offers
                    params.bts = 'true';
                  }
                  $scope.packageMode = 'browsing';
                }

                if (!endpoint) {
                  console.log('@IPS --IFg ($scope) ', $scope);
                  return;
                }

                // make ajax call to get tiers
                $q.all(q).then(
                  function() {
                    internetPackageService.getInternetPackage(endpoint, params).then(
                      function(result) {
                        if (
                          $scope.packageMode === 'change' &&
                          result.data.changeInternetPackage.error &&
                          result.data.changeInternetPackage.error === '60010'
                        ) {
                          $scope.internetPackage = null;
                          $scope.requestData = {
                            offersLoaded: false,
                            loadError: true,
                            loading: false
                          };
                          $scope.$emit('notEligible');
                          return;
                        }

                        var internetPackages =
                          $scope.packageMode === 'change'
                            ? result.data.changeInternetPackage
                            : result.data.internetPackages;

                        // if 0 tiers are returned, treat it as a technical error; otherwise, display successfully loaded packages
                        if (
                          internetPackages &&
                          internetPackages[uteLocale.language] &&
                          internetPackages[uteLocale.language].tier &&
                          internetPackages[uteLocale.language].tier.length > 0
                        ) {
                          // set totalTiers defined in internet.js (internetCtrl) to the length of the localized data
                          $scope.totalTiers = internetPackages[uteLocale.language].tier.length;

                          // set internetPackage to data
                          $scope.internetPackage = internetPackages[uteLocale.language].tier;

                          self.attachOfferToTier();
                          self.sortOffersInTierByPrice();
                          self.setDefaultOfferInEachTier();

                          if ($scope.packageMode === 'change' && !$scope.selectedOffer) {
                            $scope.internetPackage = [];
                            console.log('@q.all --IF3 ', $scope);
                            //self.linkBrowseMode();
                            $scope.requestData = {
                              offersLoaded: false,
                              loadError: true,
                              loading: false
                            };
                          } else {
                            if ($scope.packageMode === 'browsing') {
                              console.log('@q.all --IF4 ($scope) ', $scope);
                              self.linkBrowseMode();
                            }

                            if (internetPackages.userId && internetPackages.hashKey) {
                              console.log('@q.all --IF5 ($scope) ', $scope);

                              if (
                                internetPackages.userId.expire &&
                                internetPackages.userId.expire != '-1' &&
                                new Date(internetPackages.userId.expire) > new Date()
                              ) {
                                console.log('@q.all --IF6 ($scope) ', $scope);
                                $rootScope.atg.userId = internetPackages.userId;
                              }

                              if (
                                internetPackages.hashKey.expire &&
                                internetPackages.hashKey.expire != '-1' &&
                                new Date(internetPackages.hashKey.expire) > new Date()
                              ) {
                                console.log('@q.all --IF7 ($scope) ', $scope);
                                $rootScope.atg.hashKey = internetPackages.hashKey;
                              }
                            }

                            $scope.requestData = {
                              offersLoaded: true,
                              loadError: false,
                              loading: false
                            };
                          }
                        } else {
                          $scope.internetPackage = [];
                          $scope.requestData = {
                            offersLoaded: false,
                            loadError: true,
                            loading: false
                          };
                        }

                        $timeout(self.onUpdateHeight, 50);
                      },
                      function() {
                        $scope.internetPackage = [];
                        $scope.requestData = {
                          offersLoaded: false,
                          loadError: true,
                          loading: false
                        };
                      }
                    );
                  },
                  function() {
                    $scope.internetPackage = [];
                    $scope.requestData = {
                      offersLoaded: false,
                      loadError: true,
                      loading: false
                    };
                  }
                );
              };

              // TBD
              self.refreshOffers = function(from) {
                from = from || 0;
                console.log('@internetPackageSelector @self.refreshOffers (from, self) ', from, self);

                self.init();
              };

              // samkey changed, reload offers
              $scope.$watch('userPref.samKey', function(nv, ov) {
                // console.log('@internetPackageSelector $watch --AFTER: (nv, ov, self.hasJanrainSession, $rootScope.userPref.samKey, samKeyInit) ', nv, ov, self.hasJanrainSession, $rootScope.userPref.samKey, self.samKeyInit);

                if (nv !== ov) {
                  self.samKey =
                    $rootScope.userPref && $rootScope.userPref.samKey ? $rootScope.userPref.samKey : 'default';
                  if (brtSwitchCMS.brtSwitch.fetchAddressBasedOffers) {
                    console.log('@watch --IF1');
                    self.refreshOffers();
                  }
                }
              });

              // samkey refreshed, reload offers
              $scope.$on('SAMKey-Refreshed', function() {
                console.log('@internetPackageSelector SAMKey-Refreshed');

                self.init();
              });

              $scope.$on('Events:Login:Failed', function() {
                console.log('internetPackageSelector --$VIEWCONTENTLOADED');
                self.init();
              });

              // janrainEvents.checkJanrainUiReady()
              //   .then(function () {
              //     var accessToken = commonService.accessToken;
              //     if (!accessToken) {
              //       try {
              //         var easyLoginDataJanrain = sessionStorage.getItem('easyLoginDataJanrain') || localStorage.getItem('easyLoginDataJanrain');
              //         var data = JSON.parse(easyLoginDataJanrain);
              //         if (_.has(data, 'accessToken')) {
              //           accessToken = data.accessToken;
              //         }
              //       } catch (e) {
              //         console.log('error in parsing easyLoginDataJanrain');
              //       }
              //     }
              //
              //     if (!$window.janrain.capture.ui.hasActiveSession() && accessToken) {
              //       $window.janrain.capture.ui.createCaptureSession(accessToken);
              //     }
              //
              //     if (!janrain.capture.ui.hasActiveSession()) {
              //       console.log('@internetPackageSelector .checkJanrainModalReady --IF ');
              //       self.hasJanrainSession = false;
              //       self.refreshOffers(1);
              //     } else if (janrain.capture.ui.hasActiveSession()) {
              //       console.log('@internetPackageSelector .checkJanrainModalReady --ELSEIF ');
              //       self.hasJanrainSession = true;
              //       self.refreshOffers(2);
              //     }
              //   });

              if (!$rootScope.ruiMethods.user.is.loggedIn()) {
                console.log('@internetPackageSelector .checkJanrainModalReady --IF ');
                // self.hasJanrainSession = false;
                self.refreshOffers(1);
              } else if ($rootScope.ruiMethods.user.is.loggedIn()) {
                console.log('@internetPackageSelector .checkJanrainModalReady --ELSEIF ');
                // self.hasJanrainSession = true;
                self.refreshOffers(2);
              }

              // janrainService.checkJanrainModalReady(function () {
              //   // handle auth events and reload
              //   console.log('____NNNNN ', janrain.capture.ui.hasActiveSession(), $rootScope.userPref);
              //   if (!janrain.capture.ui.hasActiveSession()) {
              //     console.log('@internetPackageSelector .checkJanrainModalReady --IF ');
              //     self.hasJanrainSession = false;
              //     self.refreshOffers(1);
              //   } else if (janrain.capture.ui.hasActiveSession()) {
              //     console.log('@internetPackageSelector .checkJanrainModalReady --ELSEIF ');
              //     self.hasJanrainSession = true;
              //     self.refreshOffers(2);
              //   }
              // });

              $scope.tierInContext = {};
              $scope.tierInContext.invalid = {};
              $scope.offerInContext = {};
              $scope.davaiStore = function(doneFn) {
                return {
                  set: function(val) {
                    var _tierInCart = $scope.tierInCart();
                    var _selectedTierId = _tierInCart.selectedOffer && _tierInCart.selectedOffer.tierId;
                    var _selectedOfferId = _tierInCart.selectedOffer && _tierInCart.selectedOffer.offerId;
                    // console.log('@naa #davaiStore ', [val.tierId === _selectedTierId, val.offerId !== _selectedOfferId], val, _selectedTierId, _selectedOfferId);

                    // NOTE TEMPORARY handle invalid offers in cart
                    if (val.tierId === _selectedTierId && val.trigger === 'auto') {
                      $scope.tierInContext.invalid[val.tierId] = _selectedOfferId;

                      $timeout(function() {
                        var _tempOfferMap = {};
                        _tempOfferMap[val.tierId] = _.chain($scope.tierInContext[val.tierId])
                          .keys()
                          .first()
                          .value();
                        // preselect the first offer in existing offers replacing the offer from cart
                        angular.extend($scope.offerInContext, _tempOfferMap);
                      });
                    }

                    $scope.tierInContext[val.tierId] = $scope.tierInContext[val.tierId] || {};
                    $scope.tierInContext[val.tierId][val.offerId] = angular.copy(val);

                    console.log('naa/davaiStore #idx', val.tierIdx + 1 === val.tierTotalCount);
                    console.log('naa/davaiStore #oidx', val.offerIdx + 1 === val.offerTotalCount);

                    // handle checking of offer once everything is ready and tiers and offers are parsed
                    ((val.tierIdx + 1 === val.tierTotalCount && val.offerIdx + 1 === val.offerTotalCount && doneFn) ||
                      angular.noop)();
                  }
                };
              };

              $scope.initTierContext = function(args) {
                $scope.davaiStore(self.setInitOffer).set(args);
              };

              self.setInitOffer = function() {
                var _defaultOfferInContext = angular.copy($scope.offerInContext);
                var _prevSelectedOffer = window.sessionStorage.getItem(PREV_SELECTED_OFFER_KEY);
                var _parsed = _prevSelectedOffer != null ? JSON.parse(_prevSelectedOffer) : {};
                var _matchedOffer = {};
                var _matchedTier = [];

                // if there was a preselected offer && it was set during anonymous state && currently is logged in
                if (_prevSelectedOffer != null && !_parsed.isAuthd && self.isAuth()) {
                  angular.extend($scope.offerInContext, _parsed);

                  // find tier in list of returned tiers from SS
                  for (var _tier in $scope.tierInContext) {
                    var _omitted = _.omit(_parsed, 'isAuthd');
                    if (_.keys(_omitted)[0] === _tier) {
                      _matchedTier = _.filter($scope.internetPackage, function(v) {
                        return v.tierId === _tier;
                      });

                      // find offer in matched tier from previous selected offer
                      for (var _offer in $scope.tierInContext[_tier]) {
                        if (_.values(_omitted)[0] === _offer) {
                          // console.log('@naa 2', _.values(_omitted)[0], _offer);

                          // set _matchedOffer with _parsed
                          _matchedOffer = $scope.tierInContext[_tier][_offer].details;
                          break;
                        }
                      }
                      break;
                    }
                  }

                  // if _matchedOffer is empty - previous selected offer is not in current offer list
                  if (_.isEmpty(_matchedOffer)) {
                    // reset $scope.offerInContext with _defaultOfferInContext to preselect defaults
                    angular.extend($scope.offerInContext, _defaultOfferInContext);

                    // remove previously selected offer
                    serviceabilityService.cleanPrevSelectedOffer();

                    // should show modal info to user that previously selected offer is not valid anymore
                    $modal.open({
                      templateUrl: 'modules/core/views/invalid-offer-modal.html',
                      controller: [
                        '$scope',
                        '$modalInstance',
                        function($scope, $modalInstance) {
                          $scope.title = 'Technical Error';
                          $scope.message = "I'm sorry we encountered an issue while proccessing your request.";
                          $scope.okButtonLabel = 'What can I get?';

                          $scope.cancel = function() {
                            $modalInstance.close();
                          };
                          $scope.ok = function() {
                            $modalInstance.close();
                          };
                        }
                      ]
                    });
                    return;
                  }

                  // remove previously selected offer
                  serviceabilityService.cleanPrevSelectedOffer();

                  // show serviceability modal
                  if ($rootScope.currentState.name === 'btsOffer') {
                    samKeyService.showAvailabilityModal(
                      'btsPromotion',
                      angular.extend(!_.isEmpty(_matchedTier) && _.isArray(_matchedTier) ? _matchedTier[0] : {}, {
                        selectedOffer: _matchedOffer
                      }),
                      'cartSummary'
                    );
                  } else {
                    samKeyService.showAvailabilityModal(
                      'internet',
                      angular.extend(!_.isEmpty(_matchedTier) && _.isArray(_matchedTier) ? _matchedTier[0] : {}, {
                        selectedOffer: _matchedOffer
                      }),
                      'cartSummary'
                    );
                  }
                }
              };

              console.log('@naa/controller/endofctrl', $scope);

              $scope.cmsVals = {};
              $timeout(function() {
                $scope.cmsVals.gbData = '200';
              });

              $scope.applyStyle = function(args, config) {
                // NOTES
                // used together with ngStyle to normalize height of tiers based on the tallest one
                // used together with directive getContentInfo
                // returns an object with regular css format to be applied in element attribute style=""
                // usage e.g.: applyStyle('height') => will default to parsed height
                // applyStyle(['height', {add: 30}]) => pass as a array tupple with an option to adjust the height with /add/ and the value in px to be added to the parsed height
                // applyStyle(['height', {dec: 30}]) => pass as an array tupple with an option to adjust the height with /dec/ and the value in px to be subtracted to the parsed height

                // console.log('@naa applyStyle',args, config);
                var _max = _.max($scope.elementHandlersHeights, function(v) {
                  return v.clientHeight;
                });
                var _methods = {};
                _methods.add = function(v1, v2) {
                  return v1 + v2;
                };
                _methods.dec = function(v1, v2) {
                  return v1 - v2;
                };
                var _style = {
                  height: _max.clientHeight,
                  'max-height': _max.clientHeight
                };
                var _temp = _.chain(_style)
                  .pick(_.isString(args) ? args : args[0])
                  .map(function(v, k) {
                    var _t = {};
                    var _o = _t || {};
                    var _v = 0;
                    var _operations = _.isArray(args) && args.length > 1 ? _.keys(args[1]) : [];
                    var _opContext = _.isArray(args) && args.length > 1 ? args[1] : {};

                    if (_operations.length) {
                      _.each(_operations, function(op) {
                        _v = _v === 0 ? v : _v;

                        _v = _methods[op](_v, _opContext[op]);
                      });
                    } else {
                      _v = v;
                    }

                    _t[k] = _v;
                    _o = _t;
                    return _o;
                  })
                  .first()
                  .value();

                return _temp;
              };
              setTimeout(function() {
                $('.offerButton').keypress(function(e) {
                  if (e.which === 13) {
                    this.click();
                  }
                });
              }, 3000);

              $scope.getRibbonText = function(tier, prefix) {
                var promoOffer = [
                  { key: 'firstDiscountAmount', value: $scope.getFirstDiscountAmount(tier) },
                  { key: 'firstDiscountPercentage', value: $scope.getFirstDiscountPercentage(tier) },
                  { key: 'firstDiscountDuration', value: $scope.getFirstDiscountDuration(tier) },
                  { key: 'secondDiscountAmount', value: $scope.getSecondDiscountAmount(tier) },
                  { key: 'secondDiscountPercentage', value: $scope.getSecondDiscountPercentage(tier) },
                  { key: 'secondDiscountDuration', value: $scope.getSecondDiscountDuration(tier) }
                ];

                var result = $scope.promos.products[tier.tierId][prefix + uteLocale.language.toLowerCase()];
                for (var i = 0; i < promoOffer.length; i++) {
                  result = result.replace('{{' + promoOffer[i].key + '}}', promoOffer[i].value);
                }
                return result;
              };

              var getDiscount = function(tier, index) {
                var discounts =
                  $scope.tierInContext[tier.tierId][$scope.offerInContext[tier.tierId]].details.offerPrice.discounts;
                if (!discounts || discounts.length == 0 || !discounts[index]) {
                  // console.error(index + ' discount not found');
                }
                return discounts && discounts.length > 0 && discounts[index];
              };

              $scope.getRegularPrice = function(tier) {
                return $scope.tierInContext[tier.tierId][$scope.offerInContext[tier.tierId]].details.offerPrice.price;
              };

              $scope.getPromotionPrice = function(tier) {
                return $scope.tierInContext[tier.tierId][$scope.offerInContext[tier.tierId]].details.offerPrice
                  .priceDisplayed;
              };

              $scope.getDisplayPrice = function(tier) {
                var price = $scope.getPromotionPrice(tier);
                return price === '0' || price === 0 || !price ? $scope.getRegularPrice(tier) : price;
              };

              $scope.getFirstDiscountAmount = function(tier) {
                var discount = getDiscount(tier, 0);
                return discount ? discount.discountAmount : '';
              };
              $scope.getFirstDiscountPercentage = function(tier) {
                var discount = getDiscount(tier, 0);
                return discount ? discount.discountPercentage : '';
              };
              $scope.getFirstDiscountDuration = function(tier) {
                var discount = getDiscount(tier, 0);
                return discount ? discount.discountDuration : '';
              };
              $scope.getSecondDiscountAmount = function(tier) {
                var discount = getDiscount(tier, 1);
                return discount ? discount.discountAmount : '';
              };
              $scope.getSecondDiscountPercentage = function(tier) {
                var discount = getDiscount(tier, 1);
                return discount ? discount.discountPercentage : '';
              };
              $scope.getSecondDiscountDuration = function(tier) {
                var discount = getDiscount(tier, 1);
                return discount ? discount.discountDuration : '';
              };
            }
          ],
          link: function(scope, elem, attr, ctrl) {
            // console.log('@internetPackageSelector:link (ctrl) ', ctrl);

            (scope.user = {}), (scope.user.actions = {}), (scope.user.state = {});

            scope.user.actions = {
              isEligible: ctrl.isEligibleToCheckout
            };
            scope.user.state = {
              isAuth: ctrl.isAuth,
              isLoggedIn: ctrl.isLoggedIn,
              isAgent: ctrl.isAgent,
              userContext: ctrl.userContext
            };
            scope.hasInternetService = ctrl.customerHasInternetService;
            console.log('@internetPackageSelector @linkFn (ctrl.hasJanrainSession) ', ctrl.hasJanrainSession);
            console.log('@naa/linkFn #this', scope, ctrl);
          }
        };
      }
    ]);
})();
